export default __webpack_public_path__ + "static/media/bild.71c52dbf.svg";